var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "home"
  }, [_c("h1", [_vm._v(_vm._s(_vm.$t("Weclome"))), _c("span", [_vm._v(_vm._s(_vm.userInfo.name))]), _vm._v(_vm._s(_vm.$t("WeclomeTo")))])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };